<template>
  <div data-view="logout" />
</template>

<script>
  export default {
    created() {
      this.logout();
    },
    methods: {
      logout() {
        return this.$store.dispatch('auth/logout').catch((err) => err);
      },
    },
  };
</script>
